<template>
  <div class="box_page">
    <el-dialog
  :title="$t('other.a1098')"
  :visible.sync="propertystatus"
  width="60%"
  >
  <el-form  :inline="true" :model="formInline" class="demo-form-inline">
  <el-form-item :label="$t('other.a1110')">
    <el-input v-model="formInline.user" :placeholder="$t('other.a1110')"></el-input>
  </el-form-item>
  <el-form-item :label="$t('other.a1111')">
    <el-input v-model="formInline.region" :placeholder="$t('other.a1111')"></el-input>
  </el-form-item>
  
</el-form>
  <span slot="footer" class="dialog-footer">
    <el-button @click="propertystatus = false">{{$t('other.a106')}}</el-button>
    <el-button type="primary" @click="propertyadd">{{$t('other.a279')}}</el-button>
  </span>
</el-dialog>
    <el-dialog
  :title="$t('other.a1175')"
  :visible.sync="numbersstatus"
  width="50%"
  >
  <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="100px" class="demo-dynamic">
  
  <el-form-item
    v-for="(domain, index) in dynamicValidateForm.domains"
    
    :key="domain.key"
    :prop="'domains.' + index + '.value'"
    :rules="{
      required: true, message: $t('other.a1447'), trigger: 'blur'
    }"
  >
    <el-input v-model="domain.value" style="width:70%"></el-input><el-button @click.prevent="removeDomain(domain)">{{$t('other.a312')}}</el-button>
  </el-form-item>
  <el-form-item>
    <!-- <el-button type="primary" @click="submitForm('dynamicValidateForm')">{{$t('other.a145')}}</el-button> -->
    <el-button @click="addDomain">{{$t('other.a1448')}}</el-button>
    <el-button @click="resetForm('dynamicValidateForm')">{{$t('other.a1449')}}</el-button>
  </el-form-item>
</el-form>
  <span slot="footer" class="dialog-footer">
    <el-button @click="numbersstatus = false">{{$t('other.a106')}}</el-button>
    <el-button type="primary" @click="succednum">{{$t('other.a279')}}</el-button>
  </span>
</el-dialog>
    <!-- 采购员帐号详情（最多只能创建3个私有仓的帐号） -->
		<el-dialog
		  :title="$t('other.a1450')"
		  :visible.sync="purchaseDia"
		  width="50%"
		  >
		  <div style="margin-bottom:20px;flot:right">
			  <el-button size="small" type="primary" @click="buyerDia=true">{{$t('other.a1453')}}</el-button>
		  </div>
		  <el-table
		     border
			:data="purchaseList"
			style="width: 100%">
			<el-table-column
				prop="userId"
				:label="$t('other.a1451')"
				>
			</el-table-column>
			<!-- <el-table-column
				prop="userName"
				:label="$t('other.a1452')"
				>
			</el-table-column> -->
      <el-table-column
      prop="userName"
				:label="$t('other.a1452')">
      <template slot-scope="scope">
         <div>
           <span>{{scope.row.userName}}</span>
           <span v-show="scope.row.isSellerPurchaseLeader==1" style="color:red;font-size:8px;margin-left:8px; cursor: pointer;">({{$t('other.a1454')}})</span>
           <span v-show="scope.row.isSellerPurchaseLeader==null || scope.row.isSellerPurchaseLeader==0" style="color: #409eff;font-size:8px;margin-left:8px; cursor: pointer;" @click="setLeaders(scope.row)">{{$t('other.a1455')}}</span>
           </div>
      </template>
    </el-table-column>
			<el-table-column
				:label="$t('other.a57')"
				>
				<template slot-scope="props">
					<span>{{getTime(props.row.createTime)}}</span>
				</template>
			</el-table-column>
			</el-table>
		
		  <span slot="footer" class="dialog-footer">
		    <el-button type="primary" @click="purchaseDia = false">{{$t('shopaccess.cancel')}}</el-button>
		  </span> 
		</el-dialog>
    <el-dialog
		:title="$t('other.a1456')"
		:visible.sync="buyerDia"
		width="30%"
		>
		<el-form :model="buyUser" ref="buyUser" label-width="110px" class="demo-dynamic">
			<el-form-item
				prop="userName"
				:label="$t('other.a1452')"
				:rules="[{ required: true, message: $t('other.a1460'), trigger: 'blur' }]"
			>
				<el-input size="medium" v-model="buyUser.userName" :placeholder="$t('other.a1457')"></el-input>
			</el-form-item>
			<el-form-item
				prop="password"
				:label="$t('other.a464')"
				:rules="[{ required: true, message: $t('other.a1461'), trigger: 'blur' }]"
			>
				<el-input size="medium" type="password" v-model="buyUser.password" :placeholder="$t('other.a1458')"></el-input>
			</el-form-item>
			<el-form-item
				prop="secondpassword"
				:label="$t('other.a431')"
				:rules="[{ required: true, message: $t('other.a1461'), trigger: 'blur' }]"
			>
				<el-input size="medium" type="password" v-model="buyUser.secondpassword" :placeholder="$t('other.a1459')"></el-input>
			</el-form-item>
			
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button @click="buyerDia = false">{{$t('other.a106')}}</el-button>
			<el-button type="primary" @click="createBuyerAccount()">{{$t('other.a279')}}</el-button>
		</span>
		</el-dialog>
     <el-dialog
  :title="$t('other.a1129')"
  :visible.sync="depotadd"
  width="30%"
  >
  
   <el-input v-model="warehousesValue.warehouseName" :placeholder="$t('other.a1130')"></el-input>
  <span slot="footer" class="dialog-footer">
    <el-button @click="depotadd = false">{{$t('other.a106')}}</el-button>
    <el-button type="primary" @click="depotsussced">{{$t('other.a279')}}</el-button>
  </span>
</el-dialog>
     <el-dialog :title="$t('other.a1136')" :visible.sync="dialogFormVisible">
      <el-form ref="form" :model="sizeForm" label-width="120px" size="mini">
        <el-form-item :label="$t('other.a1133')">
          <el-input v-model="sizeForm.address" type="textarea"></el-input>
        </el-form-item>
        <el-form-item :label="$t('other.a1134')">
          <!-- <el-input v-model="sizeForm.clearingFrom"></el-input> -->
          <el-select
            v-model="sizeForm.clearingFrom"
            :placeholder="$t('other.a50')"
            size="mini"
          >
            <el-option
              v-for="item in options"
              :key="item.values"
              :label="item.label"
              :value="item.values"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('other.a1135')">
          <el-input v-model="sizeForm.paymentCycle"></el-input>
        </el-form-item>
        <el-form-item :label="$t('other.a1137')">
          <!-- <el-input v-model="formLabelAlign.paymentMethod" size="mini"></el-input> -->
          <el-select
            v-model="sizeForm.paymentMethod"
            :placeholder="$t('other.a50')"
            size="mini"
           
          >
            <el-option
              v-for="item in options"
              :key="item.values"
              :label="item.label"
              :value="item.values"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('other.a1141')">
          <el-input v-model="sizeForm.supplier"></el-input>
        </el-form-item>
        <el-form-item :label="$t('other.a1138')">
          <!-- <el-input v-model="sizeForm.typeOfShipping"></el-input> -->
            <el-select
            v-model="sizeForm.typeOfShipping"
            :placeholder="$t('other.a50')"
            size="mini"
          >
            <el-option
              v-for="item in transportation"
              :key="item.values"
              :label="item.label"
              :value="item.values"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{$t('other.a106')}}</el-button>
        <el-button type="primary" @click="successAdd"
          >{{$t('other.a279')}}</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :title="$t('other.a1462')"
      :visible.sync="dialogTableVisible"
      width="85%"
    >
      <div style="margin-right: 15px">
        <el-input
          size="medium"
          style="width: 250px; margin-right: 5px"
          v-model="input"
          :placeholder="$t('other.a1327')"
        ></el-input>
        <el-button
          size="medium"
          tyle="margin-right:5px"
          type="primary"
          icon="el-icon-search"
          @click="search()"
          >{{$t('other.a27')}}</el-button
        >
        <el-button
          size="medium"
          tyle="margin-right:5px"
          type="primary"
          @click="addGoods()"
          >{{$t('other.a1463')}}</el-button
        >
      </div>
      <el-table
        ref="multipleTable"
        :data="overDataList"
        tooltip-effect="dark"
        border
        style="width: 100%"
        max-height="450px"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="NO.">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('other.a1374')">
          <template slot-scope="scope">
            <div class="pic_box">
              <img style="width: 100%" :src="scope.row.image" />
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('other.a1120')" width="220">
          <template slot-scope="scope">
            <div class="order_time">SKU：{{ scope.row.skuName }}</div>
            <div class="order_time">{{$t('other.a226')}}{{ scope.row.cusCode }}</div>
            <div class="order_time">{{$t('other.a1166')}}：{{ scope.row.storeName }}</div>
            <div class="order_time">{{$t('other.a799')}}：{{ scope.row.userId }}</div>
            <div class="order_time">
              {{$t('other.a1167')}}(cm)：{{ scope.row.packageLength }} x
              {{ scope.row.packageLength }} x {{ scope.row.packageHeight }}
            </div>
            <div class="order_time">{{$t('other.a1168')}}(kg)：{{ scope.row.weight }}</div>
            <div>
              {{$t('other.a1169')}}：{{ scope.row.address ? scope.row.address : $t('other.a354') }}
            </div>
            <!-- <div class="order_time">产品尺码：{{ scope.row.productId }}</div>
            <div class="order_time">{{$t('other.a1168')}}(kg)：{{ scope.row.weight }}</div>
            <div class="order_time">供应商品号：{{ scope.row.productId }}</div>
            <div class="order_time">{{$t('other.a1261')}}：{{ scope.row.productId }}</div>
            <div class="order_time">产品销售人：{{ scope.row.userId }}</div>
            <div class="order_time">产品采购人：{{ scope.row.userId }}</div>
            <div class="order_time">产品开发人：{{ scope.row.userId }}</div> -->
          </template>
        </el-table-column>
        <el-table-column :label="$t('other.a1113')" width="220">
          <template slot-scope="scope">
            <div class="order_time">{{ scope.row.userId }}</div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('other.a1495')" width="220">
          <template slot-scope="scope">
            <div class="order_time">{{ getnum(scope.row.price) }}RMB</div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('other.a1121')" width="220">
          <template slot-scope="scope">
            <div>
              {{$t('other.a1037')}}
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('other.a1122')"
                placement="top-start"
              >
                <i class="el-icon-question oook"></i>:
              </el-tooltip>
              ：{{ scope.row.stock }}
            </div>
            <div>
              {{$t('other.a1171')}}
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('other.a1123')"
                placement="top-start"
              >
                <i class="el-icon-question oook"></i>:
              </el-tooltip>
              ：{{ scope.row.storeNum }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('other.a33')">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="handleEdit(scope.$index, scope.row)"
              >{{$t('other.a29')}}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <div class="box_top">
      <div class="top_title">
        <div style="font-size: 20px; font-weight: bold; margin-left: 10px">
          {{$t('other.a1465')}}
        </div>
        <div>
          <el-button type="primary" size="mini" @click="Submitaudit"
            >{{$t('other.a1496')}}({{$t('other.a1497')}}：{{priceAll}})</el-button
          >
          <!-- <el-button type="primary" size="mini" @click="deletecart"
            >清空</el-button
          > -->
          <el-button type="primary" size="mini" @click="goback"
            >{{$t('other.a1498')}}</el-button
          >
          <el-button type="primary" size="mini" @click="gopeoduct"
            >{{$t('other.a1499')}}</el-button
          >
          <!-- <el-button type="primary" size="mini" @click="submintpro"
            >{{$t('other.a1279')}}</el-button
          > -->
        </div>
      </div>
      <div class="top_body">
        <div style="margin: 20px">
          <el-form
            :label-position="labelPosition"
            label-width="100px"
            :model="formLabelAlign"
          >
            <el-form-item :label="$t('other.a1467')" required>
              <el-select
                @change="getOverseaData()"
               
                v-model="warehouseId"
                :placeholder="$t('other.a914')"
                size="mini"
              >
                <el-option
                  v-for="item in warehouseOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('other.a1468')" required width="80px">
              <el-radio-group
                v-model="formLabelAlign.isTransit"
                @change="radiochange"
              >
                <el-radio :label="1">{{$t('other.a1158')}}</el-radio>
                <el-radio :label="0">{{$t('other.a1157')}}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              :label="$t('other.a1469')"
              required
              width="80px"
              v-show="formLabelAlign.isTransit == 1"
            >
              <!-- <el-input v-model="formLabelAlign.transitWarehouse" size="mini"></el-input> -->
              <el-select
                v-model="formLabelAlign.transitWarehouse"
                :placeholder="$t('other.a1112')"
                size="mini"
              >
                <el-option
                  v-for="item in houseData"
                  :key="item.warehouseId"
                  :label="item.warehouseName"
                  :value="item.warehouseId"
                >
                </el-option>
              </el-select>
              <span style="color: #409eff;font-size:12px;margin-left:8px; cursor: pointer;" @click="addwarehouse">{{$t('other.a1448')}}</span>
            </el-form-item>
            <el-form-item :label="$t('other.a1470')" required width="80px">
              <el-radio-group
                v-model="formLabelAlign.isPublicPurchase"
                @change="purchaseradio"
              >
                <el-radio :label="false" disabled >{{$t('other.a1471')}}</el-radio>
                <el-radio :label="true" disabled >{{$t('other.a1144')}}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('other.a1472')" required width="80px" v-show="formLabelAlign.isPublicPurchase == false">
              <!-- <el-input
                v-model="formLabelAlign.buyerUserId"
                size="mini"
              ></el-input> -->
              <el-select
                v-model="formLabelAlign.buyerUserId"
                :placeholder="$t('other.a50')"
                size="mini"
                
              >
                <el-option
                  v-for="item in purchaseList"
                  :key="item.userId"
                  :label="item.userName"
                  :value="item.userId"
                >
                </el-option>
              </el-select>
              <span style="color: #409eff;font-size:12px;margin-left:8px; cursor: pointer;" @click="openstaff">{{$t('other.a1448')}}</span>
              <span style="color: red;font-size:12px;margin-left:8px; cursor: pointer;">*{{$t('other.a1474')}}</span>
            </el-form-item>
            <el-form-item :label="$t('other.a1473')" required width="80px" v-show="formLabelAlign.isPublicPurchase == true">
              <!-- <el-input
                v-model="formLabelAlign.buyerUserId"
                size="mini"
              ></el-input> -->
              <el-select
                v-model="formLabelAlign.buyerUserId"
                :placeholder="$t('other.a1475')"
                size="mini"
                
              >
                <el-option
                  v-for="item in PublicList"
                  :key="item.userId"
                  :label="item.userName"
                  :value="item.userId"
                >
                </el-option>
              </el-select>
             
            </el-form-item>
            <el-form-item :label="$t('other.a1476')">
              <!-- <el-input
                v-model="formLabelAlign.buyerUserLeaderId"
                size="mini"
              ></el-input> -->
              <el-select
                v-model="formLabelAlign.buyerUserLeaderId"
                :placeholder="$t('other.a50')"
                size="mini"
                :disabled="formLabelAlign.isPublicPurchase == true"
              >
                <el-option
                  v-for="item in groupleader"
                  :key="item.userId"
                  :label="item.userName"
                  :value="item.userId"
                >
                </el-option>
              </el-select>
              <span style="color: #409eff;font-size:12px;margin-left:8px; cursor: pointer;" @click="openpuchse">{{$t('other.a1477')}}</span>
              <span style="color: red;font-size:12px;margin-left:8px; cursor: pointer;">*{{$t('other.a1474')}}</span>
            </el-form-item>
            <!-- <el-form-item label="头程费用:">
              <el-input
                v-model="formLabelAlign.costOfFirstTransport"
                size="mini"
              ></el-input>
            </el-form-item>
            <el-form-item label="仓库贴单费用:">
              <el-input
                v-model="formLabelAlign.costOfWarehouseReceipt"
                size="mini"
              ></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="结算方式:">
              <el-input v-model="formLabelAlign.type" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="币种:">
              <el-input v-model="formLabelAlign.name" size="mini"></el-input>
            </el-form-item> -->
            <el-form-item :label="$t('other.a1137')">
              <!-- <el-input v-model="formLabelAlign.paymentMethod" size="mini"></el-input> -->
              <el-select
                v-model="formLabelAlign.paymentMethod"
                :placeholder="$t('other.a50')"
                size="mini"
                disabled 
              >
                <el-option
                  v-for="item in options"
                  :key="item.values"
                  :label="item.label"
                  :value="item.values"
                >
                </el-option>
              </el-select>
              <span style="font-size:10px;color:red;margin-left:5px">*{{$t('other.a1478')}}</span>
            </el-form-item>
            <!-- <el-form-item label="收款方式:">
              <el-input v-model="formLabelAlign.type" size="mini"></el-input>
            </el-form-item> -->
            <el-form-item :label="$t('other.a1483')">
              <el-input
                style="width:70%"
                v-model="formLabelAlign.netPurchaseOrder"
                size="mini"
              ></el-input>
              <span style="color: #409eff;font-size:12px; cursor: pointer;" @click="openseats">{{$t('other.a1479')}}</span>
            </el-form-item>
            <el-form-item :label="$t('other.a1484')">
              <el-input
                v-model="formLabelAlign.description"
                size="mini"
                type="textarea"
              ></el-input>
            </el-form-item>
             <el-form-item :label="$t('other.a1485')">
              <el-input
                v-model="formLabelAlign.domesticWaybillNo"
                size="mini"
                type="text"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item :label="$t('other.a1113')">
            
              <el-select
              disabled 
                v-model="formLabelAlign.supplier"
                :placeholder="$t('other.a1113')"
                size="mini"
                 @change="checktvalue"
              >
                <el-option
                  v-for="item in supplierData"
                  :key="item.id"
                  :label="item.supplier"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <span style="color: #409eff;font-size:12px;margin-left:8px; cursor: pointer;" @click="addsuilper">{{$t('other.a1448')}}</span>
            </el-form-item> -->
            <!-- <el-form-item :label="$t('other.a1486')">
            
              <el-select
                v-model="formLabelAlign.createUserName"
                :placeholder="$t('other.a1150')"
                size="mini"
               
              >
                <el-option
                  v-for="item in groupsData"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
             <span style="color: red;font-size:12px;margin-left:8px; cursor: pointer;">*{{$t('other.a1474')}}</span>
            </el-form-item> -->
          </el-form>
        </div>
        <div style="margin: 20px">
          <el-form
            :label-position="labelPosition"
            label-width="120px"
            :model="formLabelAlign"
          >
            
            <!-- <el-form-item label="国内运输费用:">
              <el-input
                v-model="formLabelAlign.costOfNativeTransport"
                size="mini"
              ></el-input>
            </el-form-item> -->
            <el-form-item
            v-for="(item,index) in attributeData"
            :label="item.attributeName"
            :key="index"
            
            
          >
            <el-input v-model="item.attributeValue" size="mini"></el-input><el-button @click.prevent="removeitem(item)" size="samll">{{$t('other.a312')}}</el-button>
          </el-form-item>
          </el-form>
          
          <!-- <el-form :model="purchaseOrderAttributesData" ref="purchaseOrderAttributesData" label-width="100px" class="demo-dynamic">
  
              <el-form-item
                v-for="(domain, index) in  purchaseOrderAttributesData.purchaseOrderAttributes"
                :lable="domain.attributeName"
                :key="index"
                :prop="'domains.' + index + '.value'"
              >
                <el-input v-model="domain.attributeValue" size="mini"></el-input>
              </el-form-item>
             
            </el-form> -->
           <el-button type="primary" icon="el-icon-plus" size="small" @click="addattribute">{{$t('other.a1480')}}</el-button>
        </div>
        <div></div>
      </div>
      <!-- <div class="center_body">
        <div style="font-size: 20px; font-weight: bold; margin-left: 10px">
          快速填充
        </div>
        <div class="cen_body_ff">
          <div>
            <div>{{$t('other.a1125')}}：</div>
            <div><el-input size="mini" v-model="input1"> </el-input></div>
          </div>
          <div>
            <div>采购参考价：</div>
            <div><el-input size="mini" v-model="input1"> </el-input></div>
          </div>
          <div>
            <div>税率：</div>
            <div><el-input size="mini" v-model="input1"> </el-input></div>
          </div>
          <div><el-button size="mini" type="info">填充</el-button></div>
        </div>
      </div> -->
      <div class="footer_body">
        <div style="font-size: 20px; font-weight: bold; margin-left: 10px">
          {{$t('other.a1149')}}
        </div>
      </div>
     
        <el-table
          ref="multipleTable"
          :data="tableData"
          :default-expand-all="true"
          tooltip-effect="dark"
          style="width: 100%"
          :default-sort="{ prop: 'date', order: 'descending' }"
         
        >
          <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
        
          <el-table-column :label="$t('other.a1374')">
            <template slot-scope="scope">
              <el-popover placement="top" title="" trigger="hover">
                <img
                  :src="scope.row.image"
                  style="width: 180px; hright: 180px"
                />
                <img
                  slot="reference"
                  :src="scope.row.image"
                  :alt="scope.row.image"
                  style="max-height: 90px; max-width: 90px"
                />
              </el-popover>
              <!-- <div class="pic_box">
                <img style="width: 100%" :src="scope.row.image" />
              </div> -->
            </template>
          </el-table-column>
          <el-table-column :label="$t('other.a1120')" width="220">
            <template slot-scope="scope">
              <div class="order_time">SKU：{{scope.row.skuName}}
                  <!-- <el-input
                  v-model="scope.row.skuName"
                  @input="onExchanges(scope.row,scope.$index)"
                  type="textarea"
                /> -->
                </div>
              <!-- <div class="order_time">产品采购价：{{ scope.row.price }}
                <el-input
                  v-model="scope.row.price"
                  @input="onExchanges(scope.row,scope.$index)"
                  type="textarea"
                />
              </div> -->
              <div class="order_time">{{$t('other.a226')}}{{scope.row.cusCode}}
                  <!-- <el-input
                  @blur="scope.row.cusCode=Number(scope.row.cusCode)"
                  v-model="scope.row.cusCode"
                  @input="onExchange(scope.$index)"
                  type="text"
                /> -->
                  <!-- {{ scope.row.cusCode }} -->
                  </div>
              <div class="order_time">{{$t('other.a1166')}}：{{ scope.row.storeName }}</div>
              <div class="order_time">{{$t('other.a799')}}：{{ scope.row.userId }}</div>
              <div class="order_time" style="font-size:15px;color:#409eff">{{$t('other.a1464')}}：{{ scope.row.wholesalePrice }}</div>
              <div class="order_time">
                {{$t('other.a1167')}}(cm)：{{ scope.row.packageLength }} x
                {{ scope.row.packageLength }} x {{ scope.row.packageHeight }}
              </div>
              <div class="order_time">{{$t('other.a1168')}}(kg)：{{ scope.row.weight }}</div>
              <div>
                {{$t('other.a1169')}}：{{ scope.row.address ? scope.row.address : $t('other.a354') }}
              </div>
              <!-- <div class="order_time">产品尺码：{{ scope.row.productId }}</div>
            <div class="order_time">{{$t('other.a1168')}}(kg)：{{ scope.row.weight }}</div>
            <div class="order_time">供应商品号：{{ scope.row.productId }}</div>
            <div class="order_time">{{$t('other.a1261')}}：{{ scope.row.productId }}</div>
            <div class="order_time">产品销售人：{{ scope.row.userId }}</div>
            <div class="order_time">产品采购人：{{ scope.row.userId }}</div>
            <div class="order_time">产品开发人：{{ scope.row.userId }}</div> -->
            </template>
          </el-table-column>
          <el-table-column :label="$t('other.a1125')">
            <template slot-scope="scope">
              <div style="width: 80px">
                <!-- <span>{{ scope.row.amount }}</span> -->
                <el-input
                  v-model="scope.row.amount"
                  @input="onExchanges(scope.$index)"
                  type="text"
                />

                <!-- <i  v-show="!scope.row.amountChecked"  class="el-icon-edit" @click="editClick(scope.$index, scope.row)"></i> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('other.a1500')">
            <template slot-scope="scope">
              <div style="width: 80px">
                <span style="color:#409eff;font-size:15px;">{{ scope.row.amount * scope.row.wholesalePrice }}{{$t('other.a54')}}</span>
                

                <!-- <i  v-show="!scope.row.amountChecked"  class="el-icon-edit" @click="editClick(scope.$index, scope.row)"></i> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('other.a1127')">
            <template slot-scope="scope">
              <div style="width: 80px">
                <!-- <span>{{ scope.row.amount }}</span> -->
                <el-input
                  v-model="scope.row.remark"
                  @input="onExchange(scope.$index)"
                  type="textarea"
                />

                <!-- <i  v-show="!scope.row.amountChecked"  class="el-icon-edit" @click="editClick(scope.$index, scope.row)"></i> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('other.a33')">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)"
                >{{$t('other.a312')}}</el-button
              >
              <el-button
                size="mini"
                type="primary"
                v-if="scope.row.flag"
                @click="addcart(scope.$index, scope.row)"
                >{{$t('other.a1501')}}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import userStoreItems from "../../api/moudles/userStoreItems";
import QrcodeDialog from "../../components/dialog/qrcodeDialog";
import { mapState, mapActions, mapMutations } from "vuex";
import utils from "../../utils/utils";
import userStoreItemsApi from "../../api/moudles/userStoreItems";
import api from "../../api/api";
import buyer from "../../api/moudles/account"
import md5 from 'js-md5';
import group from '../../api/moudles/group.js'


export default {
  data() {
    return {
      priceAll:0,//采购总价
      itemKey:0,
      attributeData:[],
      propertystatus:false,
      formInline: {
          user: '',
          region: ''
        },
      purchaseOrderAttributesData:{
        purchaseOrderAttributes:[
            
        ],
        purchaseOrderId:"string"
      },
      groupleader:[],
      dynamicValidateForm: {
          domains: [{
            value: ''
          }],
          
        },
      numbersstatus:false,
      purchaseList:[],
      PublicList:[],
      purchaseDia:false,
      buyUser:{
				password:null,
				userId:JSON.parse(localStorage.getItem('userInfo')).userId,
				userName:null,
				secondpassword:null
			},
      buyerDia:false,
      depotadd:false,
      warehousesValue:{
          createUserId: JSON.parse(localStorage.getItem("userInfo")).userId,
          createdTime: "2021-09-06T03:26:49.136Z",
          udpatedTime: "2021-09-06T03:26:49.136Z",
          warehouseId: "string",
          warehouseName: ""
        },
       transportation: [
        {
          values: this.$t('other.a1217'),
          label: this.$t('other.a1217'),
        },
        {
          values: this.$t('other.a1218'),
          label: this.$t('other.a1218'),
        },
        {
          values: this.$t('other.a1219'),
          label: this.$t('other.a1219'),
        },
      ],
      sizeForm: {
        address: "",
        clearingFrom: "",
        paymentCycle: "",
        paymentMethod: "",
        supplier: "",
        typeOfShipping: "",
        createdTime:"2021-09-03T02:05:39.002Z",
        id: "string",
        productId: "string",
        userId: JSON.parse(localStorage.getItem("userInfo")).userId,
        updatedTime:"2021-09-03T02:05:39.002Z",
      },
        dialogFormVisible:false,
      formLabelAlign: {
        isFromPlatform:true,
        advanceRate:0,
        paymentDeadline:0,
        totalAmount:0,
        isPublicPurchase:true,
        buyerUserId:"",
        buyerUserLeaderId: JSON.parse(localStorage.getItem("userInfo")).userId,
        // costOfFirstTransport: null,
        // costOfWarehouseReceipt: null,
        // costOfNativeTransport	: null,
        createUserId: JSON.parse(localStorage.getItem("userInfo")).userId,
        createUserName : JSON.parse(localStorage.getItem("userInfo")).userId,
        createdTime: "2021-09-06T04:16:11.798Z",
        description: "",
        domesticWaybillNo:"",
        firstAuditTime: "2021-09-06T04:16:11.798Z",
        isTransit: 0,
        netPurchaseOrder: "",
        orderStatus: "FIRST_AUDITING",
        paymentMethod: "",
        predictedArriveTime: "2021-09-06T04:16:11.798Z",
        purchaseOrderId: "string",
        purchaseOrderProducts: [
          {
            amount: 0,
            createdTime: "2021-09-06T04:16:11.798Z",
            id: "string",
            orderId: "string",
            price:0,
            productId: "",
            remark:"",
            productSkuId: "",
            updatedTime: "2021-09-06T04:16:11.798Z",
          },
        ],
        rejectReason: "string",
        secondAuditTime: "2021-09-06T04:16:11.798Z",
        storeId:"",
        supplier: "",
        timeLimitOfFirstTransport: "string",
        transitWarehouse: "",
        updatedTime: "2021-09-06T04:16:11.798Z",
      },
      options: [
        {
          values: this.$t('other.a1220'),
          label: this.$t('other.a1220'),
        },
        {
          values: this.$t('other.a1221'),
          label: this.$t('other.a1221'),
        },
        {
          values: this.$t('other.a1222'),
          label: this.$t('other.a1222'),
        },
      ],
      values: this.$t('other.a1221'),
      pageTotal: 0,
      input: null,
      overDataList: [],
      page: 0,
      offset: 100,
      dataParams: {
        component: true,
        cusCode: null,
        offset: 100,
        page: 0,
        sellerId: null,
        storeId: null,
        userId: JSON.parse(localStorage.getItem("userInfo")).userId,
      },
      dialogTableVisible: false,
      gridData: [],
      supplierData: [],
      input1: "", //采购数量
      radio: 0, //是否需要中转
      warehouseId: "",
      warehouseOption: null,
      labelPosition: "right",
      //   formLabelAlign: {
      //     buyerUserId: "",
      //     buyerUserLeaderId: "",
      //     costOfFirstTransport: "",
      //     costOfWarehouseReceipt: "",
      //     createUserId: JSON.parse(localStorage.getItem("userInfo")).userId,
      //     createdTime: "2021-09-03T01:52:11.860Z",
      //     firstAuditTime: "2021-09-03T01:52:11.860Z",
      //     description: "",
      //     netPurchaseOrder: "",
      //     paymentMethod: "",
      //     transitWarehouse: "",
      //     isTransit: 0,
      //     purchaseOrderProducts: [
      //       {
      //         amount: 0,
      //         createdTime: "2021-09-03T01:52:11.860Z",
      //         id: "",
      //         orderId: "",
      //         productId: "",
      //         productSkuId: "",
      //         updatedTime: "2021-09-03T01:52:11.860Z",
      //       },
      //     ],
      //     supplier: "",
      //   },
      userId: JSON.parse(localStorage.getItem("userInfo")).userId,
      btnlist: [],
      tableData: [],
      multipleSelection: [],
      deleteSelection: [],
      houseData:[],
      purchaseList:[],
      groupsData:[],
       searchData:{
                 pageNum:1,
                 pageSize:50,
                 partnerId:0,
                 userId:"systemAdmin"
             },
      iconData:[],
    };
  },
  created() {
    this.getUserHouse();
    this.getUserSuplist();
    this.getBuyer();
    this.getGroups();
    this.getAll();
    this.getCart();
    // this.getcartgroup();
    let arr1 = [];
    let arr2 = [];
    JSON.parse(localStorage.getItem("userInfo")).stores.forEach((p) => {
      if (p.isUsed) {
        if (p.storeType == 1) {
          arr1.push({
            label: p.storeName,
            value: p.storeId,
          });
        } else {
          arr2.push({
            label: p.storeName,
            value: p.storeId,
          });
        }
      }
    });
    this.warehouseOption = [...arr1, ...arr2];
    let storeId = utils.getDefalultStoreId();
    // this.warehouseId =storeId ? storeId : this.warehouseOption[0].value
    // this.getStoreItemAndGroup();
  },
  watch: {
    input() {
      if (!this.input) {
        this.dataParams.cusCode = null;
        this.getOverseaData();
      }
    },
  },
  methods: {
      getcartgroup(){
          let params = {
        partnerId : 0,
        userId : this.userId
      }
      api
				  .getgroupcart(params)
				  .then(res => {
					 if(res.code === 200){
                      if(res.data.length !=0){
             this.iconData = res.data
            this.iconData.forEach((p) => {
              p.flag = true
              p.userId = this.userId
              p.userName = this.userId
              p.storeId = this.warehouseOption[0].value
                p.storeItems.forEach(s=>{
                    s.amount = 1;
                  
                s.amountChecked = false;
                s.remark = "";
                s.userId = this.userId;
                s.userName = this.userId
                s.storeId = this.warehouseOption[0].value
                s.storeName = this.showstorename(this.warehouseOption[0].value)
                // s.cusCode = 0
                })
                
            });
              for (let i = 0; i < this.iconData.length; i++) {
                this.iconData[i].storeItems.forEach(p => {
                  p.indexNum=i
                })
                this.tableData.push(this.iconData[i]);

              }
          }
                     }else{
                         this.$message.warning(res.msg);
                     }
					  
					  
					 console.log(res)
					 
					
                  })
      },
      
    addcart(index,row){
        console.log(row)
        row.flag = false
        let moment = this.tableData[index]; // 此处的tableData为自己的table表格绑定的data数组
        this.$set(this.tableData, index, moment);
        
        //  Vue.set(this.tableData,index,row)
        let obj = {
          groupId : 0,
          partnerId : 0,
          storeId : 0,
          
          storeItemGroup:[],
          userId:""
        }
        obj.groupId = row.groupId
         obj.storeItemGroup = row
           obj.storeId = row.storeId
            obj.userId = row.userId
            
           
      
            console.log(obj)
        api
        .copycart(obj)
        .then(res => {
          console.log(res)
            if(res.code === 200){
                this.$message.success(this.$t('other.a1502'))
               this.tableData[index] = res.data
            }else{
                this.$message.warning(res.msg)
            }
        })
    },
    getCart(){
      let params = {
        partnerId : 0,
        userId : this.userId
      }
       api
      .getcart(params)
      .then(res => {
        if(res.code == 200){
          if(res.data.length !=0){
             this.iconData = res.data
            this.iconData.forEach((p) => {
        p.userStoreItem.amount = 1;
        p.userStoreItem.amountChecked = false;
        p.userStoreItem.remark = "";
        // p.userStoreItem.userId = this.userId;
        // p.userStoreItem.storeId = this.warehouseOption[0].value
        // p.userStoreItem.storeName = this.showstorename(this.warehouseOption[0].value)
        // p.userStoreItem.cusCode = 0
      });
      for (let i = 0; i < this.iconData.length; i++) {
        this.tableData.push(this.iconData[i].userStoreItem);
      }
      let allnum = 0
      this.tableData.forEach(p=>{
        allnum += p.wholesalePrice * p.amount

      })
      this.priceAll = allnum
          }
          
          // console.log(res)
          // this.iconData = res.data
        }else{
          this.$message.warning(res.msg)
        }
      })
    },
    getAll(){
            api
				  .getpuser(this.searchData)
				  .then(res => {
					 if(res.code === 200){
                       this.PublicList = res.data.list
                        // this.tableData = res.data.list
                     }else{
                         this.$message.warning(res.msg);
                     }
					  
					  
					 
					 console.log(res);
					
                  })
        },
    purchaseradio(){
      console.log(this.formLabelAlign.isPublicPurchase)
      if(this.formLabelAlign.isPublicPurchase){
        this.formLabelAlign.buyerUserLeaderId = JSON.parse(localStorage.getItem("userInfo")).userId
        this.formLabelAlign.buyerUserId = ""
      }
    },
    getGroups(){
      let obj = {
        months :1,
        quarters:1,
        timeType:1,
        userId　: this.userId,
        years:2021
      }
        group
        .getUserGroup(obj)
        .then((res) => {
          // console.log(res);
          if(res.code =='200'){
             let arrnew = res.data.map((item, index) => {
                    return Object.assign(
                      {},
                      {
                        groupId : item.groupId,
                        name : item.name
                      }
                    );
                  });
              console.log(arrnew)
              this.groupsData = arrnew;
          }else{
            this.$message.warning(res.msg);
          }
          });
         
    },//获取用户的运营小组
    removeitem(item) {
        var index = this.attributeData.indexOf(item)
        if (index !== -1) {
          this.attributeData.splice(index, 1)
        }
      },
    propertyadd(){
      // console.log(this.formInline);
      let obj ={
            attributeId: "string",
            attributeName: this.formInline.user,
            attributeValue: this.formInline.region,
            createdTime: "2021-09-08T04:07:48.421Z",
            purchaseOrderId: "string",
            updatedTime: "2021-09-08T04:07:48.421Z"
      }
      this.attributeData.push(obj)
      // this.purchaseOrderAttributesData.purchaseOrderAttributes = this.attributeData;
      // console.log(this.purchaseOrderAttributesData);
      
      // this.attributeData.forEach((p)=>{
      //   p.purchaseOrderId = '123'
      // })
      console.log(this.attributeData)
      this.propertystatus = false
    },//添加自定义属性
    addattribute(){
      this.propertystatus = true;
    },//
    succednum(){
      // console.log(this.dynamicValidateForm.domains)
      let arr = [];
      this.dynamicValidateForm.domains.forEach((p)=>{
        
        arr.push((p.value))
      })
      let str = arr.join(",")
      // console.log(str)
      this.formLabelAlign.netPurchaseOrder = str;
      this.numbersstatus = false
      console.log(this.formLabelAlign.netPurchaseOrder)
    },//
    openseats(){
      this.numbersstatus = true
    },
    submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            alert('submit!');
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      removeDomain(item) {
        var index = this.dynamicValidateForm.domains.indexOf(item)
        if (index !== -1) {
          this.dynamicValidateForm.domains.splice(index, 1)
        }
      },
      addDomain() {
        this.dynamicValidateForm.domains.push({
          value: '',
        });
      },
    setLeaders(row){
      // console.log(row)
      let obj = {
        targetUserId　: row.userId,
        userId : this.userId
      }
      // console.log(JSON.parse(obj))
        api
        .setleader(obj)
        .then((res) => {
          console.log(res);
          if(res.code =='200'){
              this.$message.success(this.$t('other.a1487'));
              this.formLabelAlign.buyerUserLeaderId = this.$t('other.a1488')
              this.getBuyer();
          }else{
            this.$message.warning(res.msg);
          }
         
        });
    },//设定采购员
    openpuchse(){
      this.purchaseDia = true;
    },
    createBuyerAccount(){
			this.$refs.buyUser.validate((valid) => {
			if (valid) {
				if(this.buyUser.password !== this.buyUser.secondpassword){
					this.$message.warning(this.$t('other.a1489'))
					return
				}
				let obj=JSON.parse(JSON.stringify(this.buyUser))
				obj.password=md5(obj.password + 'seller')
				console.log(obj)
				buyer
				.addBuyer(obj)
				.then(res => {
				if(res.code === 200 ){
				console.log('desc',res.data)
				let name=res.data.userId
				let pas=obj.secondpassword
				let text=this.$t('other.a1490')+name+this.$t('other.a1491')+ pas
				this.$confirm(text, this.$t('other.a446'), {
				confirmButtonText: this.$t('other.a955'),
				cancelButtonText: this.$t('other.a146'),
				type: 'success'
				}).then(() => {
          this.getBuyer();
					this.buyerDia=false
				})

				}else{
				this.$message.warning(res.msg)
				}
				})
			} else {
				return false;
			}
			});
		},//创建采购员
    openstaff(){
      this.buyerDia = true;
    },//添加采购员
    getBuyer(){
        buyer
        .getBuyer({
          userId:this.userId
        })
        .then((res) => {
          console.log(res);
          if(res.code == 200){
              this.purchaseList = res.data;
              this.groupleader = res.data.filter(function(item,index,array){
                  //元素值，元素的索引，原数组。
                  return (item.isSellerPurchaseLeader==1);
              });
              console.log(this.groupleader);
          }else{
            this.$message.warning(res.msg);
          }
         
        });
    },//获取采购员
    addwarehouse(){
      this.depotadd = true;
    },
    depotsussced(){
        api
        .createware(this.warehousesValue)
        .then((res) => {
          console.log(res);
          if(res.code =='ok'){
              this.$message.success(this.$t('other.a1227'));
              this.getUserHouse();
          }else{
            this.$message.warning(res.msg);
          }
          this.depotadd = false;
        });
    },//新增中转仓
    getUserHouse(){
      api
        .getuserhouse({
          userId : this.userId
        })
        .then((res) => {
          console.log(res);
          if(res.code =='ok'){
            this.houseData = res.warehouses;
          }else{
            this.$message.warning(res.msg);
          }
        });
    },//获取用户的所有仓库
    checktvalue(){
      console.log(this.formLabelAlign.supplier);
      api
        .getsuodetails({
          supplierId   : this.formLabelAlign.supplier
        })
        .then((res) => {
          if(res.code == 'ok'){
            this.formLabelAlign.paymentMethod = res.supplier.paymentMethod
            // console.log(res);
          }else{
            this.$message.warning(res.msg);
          }
        });
    },//根据供应商匹配支付方式
    successAdd(){
      this.dialogFormVisible =false;
      console.log(this.sizeForm);
      api
        .cteatesup(this.sizeForm)
        .then((res) => {
          if(res.code == 'ok'){
            this.$message.success(this.$t('other.a1237'));
            this.getUserSuplist();
          }else{
            this.$message.warning(res.msg);
          }
        });
    },
    addsuilper(){
      this.dialogFormVisible = true;
    },
    editClick(index, row) {
      console.log(index, row);
      row.amountChecked = true;
      // this.$set(this.tableData,index,row)
    },
    onExchanges(index){
      let moment = this.tableData[index]; // 此处的tableData为自己的table表格绑定的data数组
      // console.log('11',moment)
      

        this.$set(this.tableData, index, moment);
        let allnum = 0
        this.tableData.forEach(p=>{
            allnum += p.wholesalePrice * p.amount
        })
        this.priceAll = allnum
        console.log(this.priceAll)
    },
    onExchange(index) {
      let moment = this.tableData[index]; // 此处的tableData为自己的table表格绑定的data数组
      // console.log('11',moment)
      

        this.$set(this.tableData, index, moment);
      
      // console.log(this.tableData[index])
      // 此处是将修改的那一行的数据重新赋值给table表格对应的那一行，触发热更新
    },

    getUserSuplist() {
      api
        .getsuplist({
          userId: this.userId,
        })
        .then((res) => {
          console.log(res);
          if (res.code == "ok") {
            this.supplierData = res.productSuppliers;
          } else {
            this.$message.warning(res.msg);
          }
        });
    }, //获取用户的供应商
    getnum(integral) {
      var num = integral;
      if (typeof num == "undefined") {
        return num;
      } else {
        return Number(num).toFixed(2);
      }
    },
    handleDelete(index, rows) {
      this.tableData.splice(index, 1);
      
    },
    handleEdit(index, rows) {
      // this.tableData.push(rows);
      let arr = [];
      arr.push(rows);
      arr.forEach((p) => {
        p.amount = 1;
        p.amountChecked = false;
        p.remark = ""
      });
      this.tableData.push(arr[0]);
      console.log(this.tableData);
      this.dialogTableVisible = false;
      // console.log(index);
      // console.log(rows);
    }, //选择产品
    back(){
      location.reload() ;
    },
     deletecart(){
        // console.log(this.iconData)
        let obj = {
        partnerId : 0,
        userId : this.userId,
        userShoppingCarts : []
    }
    console.log(this.tableData)
    // let arr = []
    // this.iconData.forEach(p=>{
    //   p.storeItems.forEach(s=>{
    //     arr.push(s)
    //   })
    // })
    // console.log(arr)
        let arrnew = this.tableData.map((item, index) => {
        return Object.assign(
          {},
          {
            cuscode:item.cusCode,
            userId:this.userId
          }
        );
      });
      obj.userShoppingCarts = arrnew
      console.log(obj)
      api
      .removecart(obj)
      .then(res => {
        if(res.code == 200){
          
          console.log(res)
          // this.getcartgroup();
        //   this.iconData = res.data
        }else{
          this.$message.warning(res.msg)
        }
      })
    },
    goback(){
      this.$router.push({
        path:'/distributeProduct/community'
        
      })
    },
    gopeoduct(){
      this.$router.push({
        path:'/factorysupply/createpurchasing'
        
      })
    },
    Submitaudit() {
      if(this.tableData.length==0){
          this.$message.warning(this.$t('other.a1492'));
          return
      }
      let arr = []
      // this.tableData.forEach(p=>{
      //   p.storeItems.forEach(s=>{
      //     arr.push(s)
      //   })
      // })
      // console.log(this.formLabelAlign);
      // console.log(this.tableData);
      let arrnew = this.tableData.map((item, index) => {
        return Object.assign(
          {},
          {
            amount: parseInt(item.amount),
            createdTime: "2021-09-04T01:41:13.586Z",
            id: "string",
            orderId: "string",
            price:item.wholesalePrice,
            remark:item.remark,
            productId: item.groupId.toString(),
            productName : item.itemSku,
            productSku : item.skuName,
            productSkuId: item.cusCode,
            storeId :this.warehouseId,
            updatedTime: "2021-09-04T01:41:13.586Z",
            primaryCuscode:item.cusCode,
            primaryStoreId:item.storeId,
            primaryStoreName:item.storeName,
            supplierUserId:item.userId,
          }
        );
      });
      console.log("arrnew--", arrnew);
      this.formLabelAlign.purchaseOrderProducts = arrnew;
      console.log(this.formLabelAlign);
      api
        .createpur(this.formLabelAlign)
        .then((res) => {
          
          if (res.code == "ok") {
            this.$message.success(this.$t('other.a1493'));
            console.log(res.purchaseOrder.purchaseOrderId);
            this.submintpro(res.purchaseOrder.purchaseOrderId);
            this.deletecart();//清空购物车
            setTimeout(() => {
              // window.close();
               location.reload() ;
              
            }, 2000);
            
          } else {
            this.$message.warning(res.msg);
          }
        });
      console.log(this.tableData);
    }, //提交采购
    submintpro(purchaseOrderId){
      this.purchaseOrderAttributesData.purchaseOrderAttributes = this.attributeData;
      this.purchaseOrderAttributesData.purchaseOrderId = purchaseOrderId;
      this.purchaseOrderAttributesData.purchaseOrderAttributes.forEach((p)=>{
        p.purchaseOrderId = purchaseOrderId
      })
      console.log(this.purchaseOrderAttributesData);
      api
        .createattri(this.purchaseOrderAttributesData)
        .then((res) => {
          
          if (res.code == "ok") {
            // this.$message.success(this.$t('other.a1493'));
            console.log('添加自定义属性成功')
            
          } else {
            this.$message.warning(res.msg);
          }
        });
    },//添加自定义属性
    radiochange() {
      // console.log(this.formLabelAlign.isTransit);
      if(this.formLabelAlign.isTransit==0){
        
          this.formLabelAlign.transitWarehouse = "";
      }
    },
    getTime(time) {
      return utils.renderTime(time);
    },
    search() {
      this.dataParams.cusCode = this.input;
      this.getOverseaData();
    }, //搜索产品
    addGoods() {
      this.multipleSelection.forEach((p) => {
        p.amount = 1;
        p.amountChecked = false;
        p.remark = ""
      });
      for (let i = 0; i < this.multipleSelection.length; i++) {
        this.tableData.push(this.multipleSelection[i]);
      }
      // this.tableData = this.multipleSelection;
      console.log(this.tableData);
      this.dialogTableVisible = false;
    }, //批量选择产品
    checkchange(){
      this.tableData = [];
    },//
    showstorename(warehouseId){
        let arr = this.warehouseOption;
        let ttp = null
        arr.forEach(p=>{
            if(warehouseId == p.value){
                ttp = p.label
                return ttp
            }
        })
        return ttp==null? this.$t("other.a354") : ttp
    },
    //获取海外仓的库存产品
    getOverseaData() {
        console.log(this.warehouseOption)
      this.formLabelAlign.storeId = this.warehouseId;
      // this.tableData = [];
      this.overDataList = [];
    //   console.log(this.formLabelAlign.storeId);
    //   console.log(this.warehouseId);
      this.dataParams.storeId = this.warehouseId;
      // this.tableData.forEach(p=>{
      //     p.storeId = this.warehouseId
      //     p.storeName = this.showstorename(this.warehouseId)
      //     p.storeItems.forEach(s=>{
      //       s.storeId = this.warehouseId
      //        s.storeName = this.showstorename(this.warehouseId)
      //     })
      // })
    //   userStoreItemsApi.getStoreItem(this.dataParams).then((res) => {
    //     console.log(res);
    //     if (res.code === 200) {
    //       console.log("海外仓库数据", res.data);
    //       res.data.groups.forEach((p) => {
    //         p.itemSku = p.itemSku ? p.itemSku : this.$t('other.a260');
    //         p.createTime = utils.renderTime(p.createTime);
    //         p.checked = false;
    //         p.totalNum = 0;
    //         p.storeItems.forEach((i) => {
    //           p.totalNum += i.storeNum;
    //         });
    //       });

    //       //   this.overDataList = res.data.groups;
    //       //   this.pageTotal = res.data.count;

    //       res.data.groups.forEach((k) => {
    //         if (k.storeItems) {
    //           for (let i = 0; i < k.storeItems.length; i++) {
    //             this.overDataList.push(k.storeItems[i]);
    //           }
    //         }
    //       });
    //       console.log(this.overDataList);
    //     } else {
    //       this.$message.warning(res.msg);
    //     }
    //   });
    },
    getStoreItemAndGroup() {
      
      // console.log(this.warehouseId)
      this.getDataList = {
        offset: this.offset,
        page: this.page,
        userId: this.userId,
        independent: this.componentValue == 2 ? true : false,
        storeId: this.warehouseId,
        sellerId: this.userId,
        addition: this.componentValue == 3 ? true : false,
        component:
          this.componentValue == 1
            ? true
            : this.componentValue == 3
            ? true
            : false,
        cusCode: this.cusCode,
        isEdit: false,
      };
      //获取页面赠品的数据
      this.getData();
    },
    getData() {
      let list = JSON.parse(localStorage.getItem("godownentry"));
      console.log("ikmbv", list);
      userStoreItems.getStoreItem(this.getDataList).then((res) => {
        if (res.code === 200) {
          this.itemsCount = res.data.count;
          this.newUserstoreItem = [];
          if (!res.data.groups.length) {
            this.newUserstoreItem = [];
            return;
          }
          res.data.groups.forEach((p) => {
            p.checked02 = false;

            p.storeItems.forEach((k) => {
              if (list) {
                k.checked = list.find((item) => item.cusCode === k.cusCode);
              } else {
                k.checked = false;
              }

              if (!k.checked) {
                p.checked01 = false;
              } else {
                p.checked01 = true;
              }
            });

            p.storeItemsCopy = p.storeItems.slice(0, 4);
            this.newUserstoreItem.push(p);
          });

          console.log("list", this.newUserstoreItem);

          this.gridData = this.newUserstoreItem;
          console.log(this.gridData);
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;

      console.log(val);
    },
    handleSelectionChangeDe(val) {
      this.deleteSelection = val;
      console.log(this.deleteSelection);
    },
    toggleSelection() {
      this.tableData = [];
      // this.$refs.multipleTable.clearSelection();
    },
    addProduct() {
      if (this.warehouseId == "") {
        this.$message.warning(this.$t('other.a1494'));
      } else {
        // console.log(this.overDataList);
        // let arrData = this.overDataList;
        // if(arrData.length > 10){
        //   this.overDataList = [];
        //   this.overDataList = arrData.slice(0,10);
        //   setTimeout(() => {
        //   for(let i =11;i<arrData.length;i++){
        //     this.overDataList.push(arrData[i])
        //   }
        // }, 1000);
        // }else{
        //   this.overDataList = arrData;
        // }
        // console.log(this.overDataList.length);
        this.dialogTableVisible = true;
      }
    }, //添加产品
  },
};
</script>

<style>
.el-icon-edit {
  cursor: pointer;
  color: #409eff;
  font-size: 18px;
  margin-left: 10px;
}
.pic_box {
  width: 80px;
  height: 80px;
  border: 1px solid #eee;
  overflow: hidden;
  border-radius: 5px;
}
.order_time {
  font-size: 13px;
}
.el-form-item {
  margin-bottom: 0px;
}
.box_page {
  margin-top: 50px;
  /* padding: 10px; */
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  background: #f4f6f8;
}
.box_top {
  margin: 10px;
  width: 100%;
  background: #fff;
  /* padding: 10px; */
}
.top_title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.top_body {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  border: 1px solid #409eff;
  width: 100%;
  /* height: 500px; */
}
.center_body {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  border: 1px solid #409eff;
  width: 100%;
  flex-direction: column;
  /* padding: 10px; */

  /* margin: 10px; */
}
.footer_body {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  /* border: 1px solid  #409EFF; */
  width: 100%;
  flex-direction: column;
 
}
.cen_body_ff {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
  /* border-top: 1px solid #409EFF; */
}
.cen_body_ff div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 5px;
  font-size: 10px;
  font-weight: bold;
}
.foo_ff {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  /* margin: 5px; */
  /* border-top: 1px solid #409EFF; */
  /* padding: 5px; */
  font-size: 12px;
}
.pur_box {
  border: 1px solid #409eff;
}
</style>